import type { OrganizationFlags } from '@rtkwlf/rendall';
import { Outlet } from 'react-router-dom';

import { PermissionDeniedErrorPage } from '@platform/client/components/errors/permission-denied-error-page';
import type { FeatureFlag } from '@platform/core/feature-flags';
import { useFeatureFlag } from '@platform/core/feature-flags';

import { useHasOrganizationFlags } from '@apis/rendall/use-has-organization-flags';
import { useOrganizationParam } from '@packages/hooks/use-organization-param';

type FeatureOrOrganizationFlagGuardProps = React.PropsWithChildren<{
  featureFlag: FeatureFlag;
  organizationFlag: Partial<OrganizationFlags>;
}>;

export const FeatureOrOrganizationFlagGuard = ({
  featureFlag,
  organizationFlag,
  children,
}: FeatureOrOrganizationFlagGuardProps) => {
  const [isFeatureEnabled] = useFeatureFlag(featureFlag);
  const organizationId = useOrganizationParam();
  const hasFlags = useHasOrganizationFlags(organizationId, organizationFlag);

  const hasAccess = isFeatureEnabled || hasFlags;

  return hasAccess ? children || <Outlet /> : <PermissionDeniedErrorPage />;
};
